import {
  makeAuthenticatedRequest,
  makeAuthenticatedRequestForJoinEndLiveClass,
  makeAuthenticatedRequestWithHandling,
} from "./api";

// get ALL LIVE CLASSES APIS
export const getAllLiveClasses = async (props) => {
  const {
    id,
    search = "",
    pageNumber,
    pageSize,
    status = "",
    teacher = "",
    classroom = "",
    category = "",
    subject = "",
  } = props;
  try {
    return await makeAuthenticatedRequest(
      `/liveClasses/classroom/${id}?search=${search}&pageNumber=${pageNumber}&pageSize=${pageSize}&status=${status}&teacher=${teacher}&classroom=${classroom}&category=${category}&subject=${subject}`,
      "GET",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - liveClasses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during login:", error);
    return { ok: false, error: error };
  }
};

// get ALL LIVE CLASSES APIS
export const updateRecordingsForCompletedLiveClasses = async ({
  meetingIds,
}) => {
  const ids = meetingIds.join(",");
  try {
    return await makeAuthenticatedRequest(
      `/liveClasses/recordingsOfMeeting/${ids}`,
      "GET",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - liveClasses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during login:", error);
    return { ok: false, error: error };
  }
};

export const getLiveClassDataById = async (id) => {
  try {
    return await makeAuthenticatedRequest(`/liveClasses/${id}`, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - liveClasses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during login:", error);
    return { ok: false, error: error };
  }
};

export const updateLiveClass = async (id, updatedData) => {
  try {
    return await makeAuthenticatedRequest(
      `/liveClasses/${id}`,
      "PATCH",
      updatedData,
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during update Section:", error);
    return { ok: false, error: error };
  }
};

export const rescheduleLiveClass = async (id, updatedData = {}) => {
  try {
    return await makeAuthenticatedRequest(
      `/liveClasses/reschedule/${id}`,
      "POST",
      updatedData,
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during update Section:", error);
    return { ok: false, error: error };
  }
};

export const deleteLiveClassroom = async (id) => {
  try {
    return await makeAuthenticatedRequest(`/liveClasses/${id}`, "DELETE")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Delete Live Class :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete Live Class :", error);
    return { ok: false, error: error };
  }
};

export const deleteLiveClassroomRecordings = async (payload) => {
  try {
    return await makeAuthenticatedRequestWithHandling(
      `/liveClasses/recordings/delete`,
      "DELETE",
      JSON.stringify(payload),
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Delete Live Class :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete Live Class :", error);
    return { ok: false, error: error };
  }
};

export const getLiveClassAttendance = async (id) => {
  try {
    return await makeAuthenticatedRequest(
      `/liveClasses/attendance/${id}`,
      "GET",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - liveClasses attendance:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during attendance:", error);
    return { ok: false, error: error };
  }
};

export const joinLiveClass = async (id, payload, key = "start") => {
  try {
    return await makeAuthenticatedRequestForJoinEndLiveClass(
      `/liveClasses/${key}/${id}`,
      "POST",
      payload,
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Starting / joining live class :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during starting / joining  live class:", error);
    return { ok: false, error: error };
  }
};

export const endLiveClass = async (id, payload) => {
  try {
    const response = await makeAuthenticatedRequestForJoinEndLiveClass(
      `/liveClasses/end/${id}`,
      "POST",
      payload,
    );

    // Check if the request was successful (status code 200-299)
    if (!response.ok) {
      const errorData = await response.json();
      return { error: errorData.error || "Failed to end the live class" };
    }

    // Parse the response as JSON
    const data = await response.json();
    return { ok: true, data: data };
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during Ending live class:", error);
    return { error: error.message || "Failed to end the live class" };
  }
};

// CREATE SINGLE LIVE CLASS APIS
export const createSingleLiveClass = async (payload) => {
  try {
    return await makeAuthenticatedRequest(`/liveClasses`, "POST", payload)
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create single live class :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during create single live class:", error);
    return { ok: false, error: error };
  }
};

export const cloneLiveClasses = async (classroomId, body, successMSG) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/liveClasses/classroom/${classroomId}`,
      "POST",
      body,
      successMSG
    );
    return response.json();
  } catch (error) {
    console.error("Error during duplicating subscription:", error);
    return { ok: false, error: error };
  }
};

export const getAllInstructors = async () => {
  try {
    return await makeAuthenticatedRequest("/users?roleName=teacher", "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - liveClasses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during login:", error);
    return { ok: false, error: error };
  }
};

export const getAllClassrooms = async (isDropDown = false) => {
  try {
    const dropdownParam = isDropDown ? "&isDropDown=1" : "";
    return await makeAuthenticatedRequest(
      `/classrooms/?pageNumber=0&pageSize=10000${dropdownParam}`,
      "GET",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - classrooms:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during login:", error);
    return { ok: false, error: error };
  }
};
// CREATE SINGLE BULK CLASS APIS
export const createBulkLiveClass = async (payload) => {
  try {
    return await makeAuthenticatedRequest(
      `/liveClasses/bulk_create`,
      "POST",
      payload,
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create single live class :", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during create single live class:", error);
    return { ok: false, error: error };
  }
};

// Updated getAttendedLiveClasses to accept and include studentId and userId
export const getAttendedLiveClasses = async (classId, studentId) => {
  let url = `/liveClasses/attended/${classId}`;

  // If studentId exists, append studentId and userId as query parameters
  if (studentId) {
    url += `?studentId=${studentId}`;
  }

  const response = await makeAuthenticatedRequestWithHandling(url, "GET");
  return response.json();
};

// Updated getMissedClasses to accept and include studentId and userId
export const getMissedClasses = async (classId, studentId) => {
  let url = `/liveClasses/missing/${classId}`;

  // If studentId exists, append studentId and userId as query parameters
  if (studentId) {
    url += `?studentId=${studentId}`;
  }

  const response = await makeAuthenticatedRequestWithHandling(url, "GET");
  return response.json();
};

export const getCourses = async () => {
  try {
    return await makeAuthenticatedRequest("/courses", "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - courses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during courses:", error);
    return { ok: false, error: error };
  }
};

export const getAllClassroomOfCourse = async (courseId) => {
  try {
    return await makeAuthenticatedRequest(
      `/classrooms/course/${courseId}`,
      "GET",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - classroom of courses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during  classroom of courses:", error);
    return { ok: false, error: error };
  }
};

// get ALL LIVE CLASSES APIS
export const getAllLiveClassesForSuperAdmin = async (props) => {
  const {
    search = "",
    pageNumber,
    pageSize,
    status = "",
    teacher = "",
    classroomId = "",
    startDateTime = "",
    endDateTime = "",
    organisations = "",
    category = "",
    recording = "",
  } = props;
  try {
    return await makeAuthenticatedRequest(
      `/liveClasses/liveClassesAndRecordings?search=${search}&pageNumber=${pageNumber}&pageSize=${pageSize}&status=${status}&teacher=${teacher}&classroomId=${classroomId}&startDateTime=${startDateTime}&endDateTime=${endDateTime}&organisationId=${organisations}&category=${category}&recording=${recording}`,
      "GET",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error - liveClasses:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during login:", error);
    return { ok: false, error: error };
  }
};

// Update hourly consumption for students in a live class
export const updateHourlyConsumption = async (liveClassId) => {
  try {
    return await makeAuthenticatedRequest(
      `/subscriptions/update_hourly_consumption/${liveClassId}`,
      "POST",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Update hourly consumption error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during update hourly consumption:", error);
    return { ok: false, error: error };
  }
};
